import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    FOOT_LIST_START: 'FOOT_LIST_START',
    FOOT_LIST_SUCCESS: 'FOOT_LIST_SUCCESS',
    FOOT_LIST_FAILED: 'FOOT_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const footListStart = (data) => ({
   type: actionType.FOOT_LIST_START,
   payload: data
})

export const footListSuccess = (data) => ({
    type: actionType.FOOT_LIST_SUCCESS,
    payload: data
})

export const footListFailed = (data) => ({
    type: actionType.FOOT_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function footListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.FOOT_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.FOOT_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.FOOT_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* footListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allFoot = response.data.data.allHeightinfeets.Heightinfeets ? response.data.data.allHeightinfeets.Heightinfeets : null
       yield put(footListSuccess(allFoot));
    } else {
      messagePopup('','Foot List failed','error')   
      yield put(footListFailed('Foot List failed')) 
    }
   } catch (error) {
     messagePopup('','Foot List failed','error')   
     yield put(footListFailed('Foot List failed')) 
   }
}

export function* watchFootListSaga(){
    yield takeEvery(actionType.FOOT_LIST_START, footListSaga)
}